/**
 * faq-facility.js
 * 施設を固定指定して MicroCMS からFAQを取得・表示する Custom Element
 * 既存の faq.css のクラス名・構造に完全準拠
 */

class FaqFacility extends HTMLElement {
  connectedCallback() {
    this.serviceDomain = this.dataset.serviceDomain;
    this.apiKey        = this.dataset.apiKey;
    this.endpoint      = this.dataset.endpoint || 'faqs';
    this.facilityField = this.dataset.facilityField || 'facility';
    this.facilityValue = this.dataset.facilityValue || '';
    this.limit         = parseInt(this.dataset.limit, 10) || 100;

    this.contentEl   = this.querySelector('.faq-microcms__content');
    this.noResultsEl = this.querySelector('.faq-microcms__no-results');

    this._fetchFaqs();
  }

  async _fetchFaqs() {
    try {
      const url = this._buildUrl();
      const res = await fetch(url, {
        headers: { 'X-MICROCMS-API-KEY': this.apiKey }
      });

      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const data = await res.json();
      this._render(data.contents || []);
    } catch (err) {
      console.error('[faq-facility] fetch error:', err);
      this._showError();
    }
  }

  _buildUrl() {
    const base   = `https://${this.serviceDomain}.microcms.io/api/v1/${this.endpoint}`;
    const params = new URLSearchParams({ limit: this.limit });

    if (this.facilityValue) {
      params.set('filters', `${this.facilityField}[contains]${this.facilityValue}`);
    }

    return `${base}?${params}`;
  }

  _render(items) {
    if (items.length === 0) {
      this.contentEl.innerHTML = '';
      this.noResultsEl.style.display = 'block';
      return;
    }

    const html = items.map(item => this._itemHtml(item)).join('');

    // 既存CSSの .faq-microcms__group / .faq-microcms__group-title 構造に合わせる
    this.contentEl.innerHTML = `
      <div class="faq-microcms__group">
        ${this.facilityValue ? `<h3 class="faq-microcms__group-title">${this._esc(this.facilityValue)}</h3>` : ''}
        ${html}
      </div>`;
  }

  _itemHtml(item) {
    const q = this._esc(item.question || item.q || '');
    const a = item.answer || item.a || '';

    return `
      <div class="faq-microcms__item">
        <button class="faq-microcms__question" aria-expanded="false">
          <span class="faq-microcms__q-label">Q</span>
          <span class="faq-microcms__q-text">${q}</span>
          <span class="faq-microcms__q-icon" aria-hidden="true">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 6L8 10L12 6" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
        </button>
        <div class="faq-microcms__answer">
          <span class="faq-microcms__a-label">A</span>
          <div class="faq-microcms__answer-content">${a}</div>
        </div>
      </div>`;
  }

  _showError() {
    this.contentEl.innerHTML = '<p class="faq-microcms__error-msg">FAQの読み込みに失敗しました。</p>';
  }

  _esc(str) {
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
}

customElements.define('faq-facility', FaqFacility);

// アコーディオン（イベント委譲）
// 既存CSSは hidden 属性ではなく .is-open クラスで display を切り替える設計
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.faq-microcms__question');
  if (!btn) return;

  const item   = btn.closest('.faq-microcms__item');
  const isOpen = item.classList.contains('is-open');

  item.classList.toggle('is-open', !isOpen);
  btn.setAttribute('aria-expanded', String(!isOpen));
});